import React, { useState } from "react";
import { FaHeart, FaExchangeAlt, FaShippingFast, FaHeartBroken } from "react-icons/fa";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import StarRating from "./StarRating";
import { PiHeart, PiShareNetwork, PiShareNetworkThin } from "react-icons/pi";
import { CiApple } from "react-icons/ci";
import { AddTocartButton } from "./AddTocartButton";
import { BuyNowButton } from "./BuyNowButton";
import { BiShare } from "react-icons/bi";
import { MdOutlineFileUpload } from "react-icons/md";
import SharePopup from "../lib/SharePopup";
import Rating from "./homeComponents/Rating";

const ProductDetail = ({ product }) => {
    const [quantity, setQuantity] = useState(1);
    const [weight, setWeight] = useState("1kg");
    const [open, setOpen] = useState(null);

    const toggleAccordion = (section) => {
        setOpen(open === section ? null : section);
    };

    return (
        <div className="max-w-lg p-4 text-sm">
            {/* Title */}
            <h1 className="text-lg font-semibold mb-2">
                {product?.name}
            </h1>

            {/* Rating */}
            {/* <div className="flex items-center text-gray-500 text-xs mb-2">
                <StarRating rate={product?.rating ?? 0} />
            </div> */}

            {/* Price */}
            <div className="text-green-600 font-bold text-xl mb-2"> {Number(product?.price).toFixed(2)}</div>
            {/* <p className="text-gray-500 mb-4">Phí vận chuyển được tính khi thanh toán.</p> */}

            {/* Info */}
            <div className="text-gray-700 mb-4 space-y-1">
                {/* <p>
                    <strong>Loại:</strong> Phô mai
                </p>
                <p>
                    <strong>Mã SKU:</strong> SKU38
                </p>
                <p>
                    <strong>Thẻ:</strong> Phô mai, Bánh quy, Thực phẩm
                </p>
                <p>
                    <strong>Bộ sưu tập:</strong> Các sản phẩm bơ, Các sản phẩm phô mai, Các sản phẩm sữa,
                    Cửa hàng của chúng tôi, Bộ sưu tập thịnh hành
                </p> */}
                <p>
                    <strong>Tình trạng:</strong> {product?.countInStock ?? 0} còn hàng
                </p>
                <p>
                    <strong>Đã bán:</strong> <span>
                       {product.sold}
                    </span>
                </p>
                {/* <p>
                    <strong>Quốc Gia:</strong>
                    <span>
                        {product?.country?.map((e, i) => {
                            return (
                                i + 1 != product?.country?.length ? (e.name + ', ') : e.name
                            )
                        })}
                    </span>
                </p> */}
                {/* <p className="flex gap-2">
                <strong>Đánh giá:</strong>
                <Rating
                    value={product.rating}
                    text={`${product.numReviews} phản hồi`}
                />
                </p> */}
                
            </div>

            {/* Weight */}
            {/* <div className="mb-4">
                <p className="font-medium mb-1">Nặng</p>
                <div className="flex gap-2">
                    {["1kg", "500gm", "250gm", "100gm"]?.map((w) => (
                        <button
                            key={w}
                            onClick={() => setWeight(w)}
                            className={`px-3 py-1 border rounded ${weight === w ? "border-yellow-500 text-yellow-600" : "border-gray-300"
                                }`}
                        >
                            {w}
                        </button>
                    ))}
                </div>
            </div> */}

            {/* Quantity */}
            <div className="mb-4">
                <p className="font-medium mb-1">Số lượng</p>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => setQuantity(Math.max(1, quantity - 1))}
                        className="px-2 py-1 border rounded"
                    >
                        <AiOutlineMinus />
                    </button>
                    <span className="px-4">{quantity}</span>
                    <button
                        onClick={() => setQuantity(quantity + 1)}
                        className="px-2 py-1 border rounded"
                    >
                        <AiOutlinePlus />
                    </button>
                </div>
            </div>

            {/* Actions */}
            <div className="flex gap-2 mb-4">
                <AddTocartButton product={product} quantity={quantity} hover={2} />

                <BuyNowButton product={product} />
            </div>

            {/* <div className="flex gap-4 mb-6 text-gray-600 text-sm">
                <button className="flex items-center gap-1 hover:text-[--color-button-3]">
                    <PiHeart /> Thêm vào danh sách thích
                </button>
                <button className="flex items-center gap-1  hover:text-[--color-button-3]">
                    <PiShareNetwork /> Thêm vào so sánh
                </button>
            </div> */}

            {/* Accordion Sections */}
            

            {/* Share */}
            <SharePopup productId="67de7ed1f0a12e93cc1394e8" refCode="ABSKKJFDS" />

        </div>
    );
};

export default ProductDetail;
